/** Consulta de telas para rotas e links dinâmicos (Sprint 39).
 * A API continua responsável por autorizar cada recurso e ação.
 */
import type { Usuario } from "./api";
import { pode } from "./permissoes";

type Regra = readonly [RegExp, (u: Usuario) => boolean];
const autenticado = (_u: Usuario) => true;
const estrutura = pode.verEstrutura;
const regras: Regra[] = [
  [/^\/$/, autenticado],
  [/^\/menu$/, autenticado],
  [/^\/treinamento$/, pode.verTreinamento],
  [/^\/meus-paineis$/, pode.verPaineis],
  [/^\/cco\/mapa$/, pode.verObservabilidadeLocal],
  [/^\/cco(?:\/(?:tendencias|grafico|alarmes|analise|relatorios|qualidade|gestor|seguranca))?$/, autenticado],
  [/^\/cco\/(?:cidade|unidade)\/[^/]+$/, autenticado],
  [/^\/cco\/equipamento\/[^/]+(?:\/diagnostico)?$/, autenticado],
  [/^\/(?:rede|scada3d|videowall|manobra-automatica)$/, autenticado],
  [/^\/cadastro\/novo$/, (u) => pode.editarCadastro(u) || pode.cadastrarEmCampo(u)],
  [/^\/cadastro\/importar$/, pode.editarCadastro],
  [/^\/cadastro(?:\/[^/]+)?$/, pode.verCadastro],
  [/^\/regras\/nova$/, pode.editarRegras],
  [/^\/regras(?:\/[^/]+)?$/, autenticado],
  [/^\/admin\/usuarios\/novo$/, pode.gerenciarUsuarios],
  [/^\/admin\/usuarios(?:\/[^/]+)?$/, pode.verUsuarios],
  [/^\/admin\/empresas\/nova$/, pode.editarEstrutura],
  [/^\/admin\/empresas(?:\/[^/]+(?:\/implantacao)?)?$/, estrutura],
  [/^\/admin\/dispositivos\/novo$/, pode.editarEstrutura],
  [/^\/admin\/dispositivos$/, estrutura],
  // O detalhe também é consultado a partir do CCO › Segurança.
  [/^\/admin\/dispositivos\/[^/]+$/, autenticado],
  [/^\/admin\/conectores\/novo$/, pode.editarEstrutura],
  [/^\/admin\/conectores(?:\/[^/]+)?$/, estrutura],
  [/^\/admin\/canais$/, pode.verUsuarios],
  [/^\/admin\/feriados$/, (u) => pode.editarFeriados(u) || pode.importarFeriadosNacionais(u)],
  [/^\/admin\/referencias$/, (u) => pode.importarReferencias(u) || estrutura(u)],
  [/^\/admin\/marca$/, pode.verMarca],  // US-4503
];

export function podeAcessarRota(usuario: Usuario, destino: string): boolean {
  // Links vindos de agentes e APIs só podem abrir destinos locais conhecidos.
  if (!destino.startsWith("/") || destino.startsWith("//") || destino.includes("\\")) return false;
  try {
    const url = new URL(destino, "https://nexora.invalid");
    const caminho = decodeURIComponent(url.pathname).replace(/\/+$/, "") || "/";
    const empresa = url.searchParams.get("empresa");
    if (empresa && !pode.verEmpresa(usuario, empresa)) return false;
    return regras.find(([padrao]) => padrao.test(caminho))?.[1](usuario) ?? false;
  } catch {
    return false;
  }
}
